// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__TlHfz","empty__content":"styles_empty__content__1icel","empty__icon":"styles_empty__icon__3ysVN","empty__subtitle":"styles_empty__subtitle__3aPFm"};